import { createReducer } from 'redux-act';
import { setCurrentId, setPersonalId } from './actions';
import sharingResource from './resource';
export const initialState = {
  personal: undefined,
  current: undefined,
  organizations: {},
  filteredOrganizations: {}
};
export const fetchHandler = (state, {
  response,
  label,
  accumulate
}) => {
  if (label) {
    return {
      ...state,
      filteredOrganizations: response.data.reduce((old, current) => ({
        ...old,
        [current.id]: current
      }), accumulate ? state.filteredOrganizations : {})
    };
  }
  return {
    ...state,
    organizations: response.data.reduce((old, current) => ({
      ...old,
      [current.id]: {
        ...(state.organizations[current.id] || {}),
        ...current
      }
    }), accumulate ? state.organizations : {})
  };
};
export const fetchOneHandler = (state, {
  response,
  label
}) => ({
  ...state,
  organizations: {
    ...state.organizations,
    [label]: {
      ...(state.organizations[label] || {}),
      ...response.data
    }
  }
});
export const setCurrentHandler = (state, id) => ({
  ...state,
  current: id
});
export const setPersonalHandler = (state, id) => ({
  ...state,
  personal: id
});
const reducer = createReducer({
  [sharingResource.fetch.success.getType()]: fetchHandler,
  [sharingResource.fetchOne.success.getType()]: fetchOneHandler,
  [setCurrentId]: setCurrentHandler,
  [setPersonalId]: setPersonalHandler
}, initialState);
export default reducer;